module.exports = __webpack_public_path__ + "static/media/filter.269337cc.svg";